import { useState, useEffect } from "react";

import { Input, Button, ErrorMsg } from "@fragments";
import { EditRounded } from "@mui/icons-material";
import LinkIcon from "@mui/icons-material/Link";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";

export default function LinkInfo({ data, errors, onPatch, onRemove }) {
    const hasErrors = !!(errors && (errors.title || errors.url));
    const [open, setOpen] = useState(!!data.open || hasErrors);
    const [title, setTitle] = useState(data.title);
    const [url, setUrl] = useState(data.url);

    useEffect(() => {
        onPatch({ open });
    }, [open]);

    useEffect(() => {
        if (hasErrors) setOpen(true);
    }, [hasErrors]);

    if (!open) {
        return (
            <div className="description-link-row bsf-9">
                <div className="description-link">
                    <LinkIcon className="url-icon" />
                    <h5 className="title">{title || <i>(Não configurado)</i>}</h5>
                    <span className="url">{url}</span>
                    <Button
                        size="small"
                        color="overlay"
                        className="edit-link-btn"
                        onClick={() => setOpen(true)}
                        icon={<EditRounded />}
                    />
                </div>
            </div>
        );
    }

    return (
        <div className="link-info-block mt-2 px-2 py-1">
            <Input.Text
                autoFocus
                value={title}
                onInput={(v) => {
                    setTitle(v);
                    onPatch({ title: v });
                }}
                label="Título do link"
                size={25}
                placeholder="O título do link será o texto do botão no app"
                error={!!errors?.title}
            />
            {errors?.title && <ErrorMsg>{errors.title}</ErrorMsg>}

            <Input.Text
                className="mt-1"
                value={url}
                onInput={(v) => {
                    setUrl(v);
                    onPatch({ url: v });
                }}
                start="https://"
                color="primary"
                label="Link"
                size={150}
                placeholder="Insira o link do link"
                error={!!errors?.url}
            />
            {errors?.url && <ErrorMsg>{errors.url}</ErrorMsg>}

            <div className="mt-1 link-buttons-footer">
                <Button
                    size="small"
                    color="error"
                    onClick={onRemove}
                    endIcon={<DeleteIcon color="error" />}
                    text="Remover"
                />
                <Button
                    size="small"
                    variant="inverse"
                    onClick={() => setOpen(false)}
                    endIcon={<CheckRoundedIcon color="primary" />}
                    text="Concluir edição"
                />
            </div>
        </div>
    );
}
